import React, { FC } from "react";
import { Link } from "react-router-dom";

const Menu: FC = () => (
  <nav>
    <ul>
      <li>
        <Link to="/">Home</Link>
      </li>
      <li>
        <Link to="/list">Radio List</Link>
      </li>
    </ul>
  </nav>
);

export default Menu;
